<template>
  <div id="app">
    <div class="reveal">
      <div class="slides">
        <front :key="'SoV'">State of Vue 2k19</front>
        <slides-link></slides-link>
        <section :key="'backstory'">
          <regular-front :variant="1" :key="'Backstory'">Backstory</regular-front>
          <regular-slide :key="'announcement'">
            <h2>Announcement (Vue.js London): 21 sep. 2018</h2>
          </regular-slide>
          <regular-slide>
            <what-new></what-new>
          </regular-slide>
          <regular-slide>
            <what-new-more></what-new-more>
          </regular-slide>
        </section>
        <section :key="'actually'">
          <regular-front :variant="2">But, what is actually?</regular-front>
          <regular-slide :key="'look-on-nothing'">
            <img src="/images/where.gif" loading="lazy" width="100%" height="100%" />
          </regular-slide>
          <regular-slide :key="'project'">
            <img src="/screenshots/project.png" loading="lazy" alt="project" />
          </regular-slide>
          <regular-slide :key="'active_rfcs'">
            <img src="/screenshots/active-rfcs.png" loading="lazy" alt="active rfcs" />
          </regular-slide>
        </section>
        <section>
          <regular-front :variant="3">
            Vue 3.0
            <br />build for enterprise
          </regular-front>
          <regular-slide>
            <render-function></render-function>
          </regular-slide>
          <regular-slide>
            <render-function-create-element></render-function-create-element>
          </regular-slide>
          <regular-slide>
            <render-function-consistent-api></render-function-consistent-api>
          </regular-slide>
          <regular-slide>
            <render-function-flat-args></render-function-flat-args>
          </regular-slide>
          <regular-slide>
            <global-api-changes></global-api-changes>
          </regular-slide>
          <regular-slide>
            <global-api-changes-example-before></global-api-changes-example-before>
          </regular-slide>
          <regular-slide>
            <global-api-changes-example-after></global-api-changes-example-after>
          </regular-slide>
          <regular-slide>
            <global-api-changes-example-d-i></global-api-changes-example-d-i>
          </regular-slide>
        </section>
        <section>
          <regular-front :variant="4">Composition API</regular-front>
          <regular-slide>
            <composition-api></composition-api>
          </regular-slide>
          <regular-slide>
            <composition-api-example-template></composition-api-example-template>
          </regular-slide>
          <regular-slide>
            <composition-api-example-component></composition-api-example-component>
          </regular-slide>
          <regular-slide>
            <composition-api-example-no-component></composition-api-example-no-component>
          </regular-slide>
          <regular-slide>
            <composition-api-computed></composition-api-computed>
          </regular-slide>
          <regular-slide>
            <composition-api-computed-pass-by></composition-api-computed-pass-by>
          </regular-slide>
          <regular-slide>
            <composition-api-computed-ref></composition-api-computed-ref>
          </regular-slide>
          <regular-slide>
            <composition-api-lifecycle></composition-api-lifecycle>
          </regular-slide>
          <section>
            <composition-api-code-organization-old></composition-api-code-organization-old>
          </section>
          <section>
            <composition-api-code-organization></composition-api-code-organization>
          </section>
          <regular-slide>
            <composition-api-compare-with-react></composition-api-compare-with-react>
          </regular-slide>
          <regular-slide>
            <composition-api-try-it-now></composition-api-try-it-now>
          </regular-slide>
          <regular-slide>
            <composition-api-reference></composition-api-reference>
          </regular-slide>
        </section>
        <other-changes></other-changes>
        <back :key="'SoV-ty'">Thank you!</back>
        <back :key="'SoV-ty'">QA?!</back>
      </div>
    </div>
  </div>
</template>

<script>
import Reveal from "reveal.js/js/reveal";
import { isPdf } from "./utils";

import Front from "./blocks/Front";
import Back from "./blocks/Back";
import RegularFront from "./blocks/RegularFront";
import RegularSlide from "./blocks/RegularSlide";

import SlidesLink from "./slides/SlidesLink";
import WhatNew from "./slides/WhatNew";
import WhatNewMore from "./slides/WhatNewMore";
import RenderFunction from "./slides/RenderFunction";
import RenderFunctionCreateElement from "./slides/RenderFunctionCreateElement";
import RenderFunctionConsistentApi from "./slides/RenderFunctionConsistentApi";
import RenderFunctionFlatArgs from "./slides/RenderFunctionFlatArgs";
import GlobalApiChanges from "./slides/GlobalApiChanges";
import GlobalApiChangesExampleBefore from "./slides/GlobalApiChangesExampleBefore";
import GlobalApiChangesExampleAfter from "./slides/GlobalApiChangesExampleAfter";
import GlobalApiChangesExampleDI from "./slides/GlobalApiChangesExampleDI";
import OtherChanges from "./slides/OtherChanges";
import CompositionApi from "./slides/CompositionApi";
import CompositionApiExampleTemplate from "./slides/CompositionApiExampleTemplate";
import CompositionApiExampleComponent from "./slides/CompositionApiExampleComponent";
import CompositionApiExampleNoComponent from "./slides/CompositionApiExampleNoComponent";
import CompositionApiComputed from "./slides/CompositionApiComputed";
import CompositionApiComputedPassBy from "./slides/CompositionApiComputedPassBy";
import CompositionApiComputedRef from "./slides/CompositionApiComputedRef";
import CompositionApiLifecycle from "./slides/CompositionApiLifecycle";
import CompositionApiCodeOrganization from "./slides/CompositionApiCodeOrganization";
import CompositionApiCodeOrganizationOld from "./slides/CompositionApiCodeOrganizationOld";
import CompositionApiComareWithReact from "./slides/CompositionApiComareWithReact";
import CompositionApiTryItNow from "./slides/CompositionApiTryItNow";
import CompositionApiReference from "./slides/CompositionApiReference";

window.Reveal = Reveal;

// import("../node_modules/reveal.js/plugin/markdown/marked.js");
// import("../node_modules/reveal.js/plugin/markdown/markdown.js");
// import("../node_modules/reveal.js/plugin/notes/notes.js");
// import("../node_modules/reveal.js/plugin/highlight/highlight.js");

if (isPdf()) {
  import("../node_modules/reveal.js/css/print/pdf.css");
} else {
  import("../node_modules/reveal.js/css/print/paper.css");
}

export default {
  name: "app",
  components: {
    front: Front,
    back: Back,
    "regular-front": RegularFront,
    "regular-slide": RegularSlide,
    "slides-link": SlidesLink,
    "what-new": WhatNew,
    "what-new-more": WhatNewMore,
    "render-function": RenderFunction,
    "render-function-create-element": RenderFunctionCreateElement,
    "render-function-consistent-api": RenderFunctionConsistentApi,
    "render-function-flat-args": RenderFunctionFlatArgs,
    "global-api-changes": GlobalApiChanges,
    "global-api-changes-example-before": GlobalApiChangesExampleBefore,
    "global-api-changes-example-after": GlobalApiChangesExampleAfter,
    "global-api-changes-example-d-i": GlobalApiChangesExampleDI,
    "other-changes": OtherChanges,
    "composition-api": CompositionApi,
    "composition-api-example-template": CompositionApiExampleTemplate,
    "composition-api-example-component": CompositionApiExampleComponent,
    "composition-api-example-no-component": CompositionApiExampleNoComponent,
    "composition-api-computed": CompositionApiComputed,
    "composition-api-computed-pass-by": CompositionApiComputedPassBy,
    "composition-api-computed-ref": CompositionApiComputedRef,
    "composition-api-lifecycle": CompositionApiLifecycle,
    "composition-api-code-organization": CompositionApiCodeOrganization,
    "composition-api-code-organization-old": CompositionApiCodeOrganizationOld,
    "composition-api-compare-with-react": CompositionApiComareWithReact,
    "composition-api-try-it-now": CompositionApiTryItNow,
    "composition-api-reference": CompositionApiReference
  },
  mounted() {
    this.$nextTick(() => {
      Reveal.initialize({
        width: isPdf() ? 960 : "90%",
        height: isPdf() ? 700 : "95%",
        margin: isPdf() ? 0.1 : 0,
        minScale: isPdf() ? 0.2 : 1,
        maxScale: isPdf() ? 1.5 : 1,
        history: true,
        // pdfSeparateFragments: false,
        // pdfMaxPagesPerSlide: 1,
        fragmentInURL: true,
        slideNumber: "c/t",
        dependencies: [
          { src: "plugin/markdown/marked.js" },
          { src: "plugin/markdown/markdown.js" },
          { src: "plugin/notes/notes.js", async: true },
          { src: "plugin/highlight/highlight.js", async: true }
        ]
      });
    });
  }
};
</script>

<style>
#app {
  height: 100%;
  width: 100%;
}
</style>

<style src="../node_modules/reveal.js/css/reset.css"></style>
<style src="../node_modules/reveal.js/css/reveal.css"></style>
<style src="../node_modules/reveal.js/lib/css/monokai.css"></style>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap");

// Default mixins and settings -----------------
@import "../node_modules/reveal.js/css/theme/template/mixins";
@import "../node_modules/reveal.js/css/theme/template/settings";
// ---------------------------------------------

// Override theme settings (see ../template/settings.scss)
$backgroundColor: #fff;

$mainColor: #222;
$headingColor: #222;

$mainFontSize: 42px;
$mainFont: "Source Sans Pro", "Trebuchet MS", Helvetica, sans-serif;
$headingFont: "Source Sans Pro", "Trebuchet MS", Helvetica, sans-serif;
$headingTextShadow: none;
$headingLetterSpacing: normal;
$headingTextTransform: uppercase;
$headingFontWeight: 600;
$selectionBackgroundColor: lighten($linkColor, 25%);

$heading1Size: 2.5em;
$heading2Size: 1.6em;
$heading3Size: 1.3em;
$heading4Size: 1em;

$linkColor: #ff6600;
$linkColorHover: #999999;

:root {
  --dk1: #4a4a4a;
  --lt1: #ffffff;
  --dk2: #656565;
  --lt2: #e7e6e6;
  --accent1: #4b4c4d;
  --accent2: #ea5b25;
  --accent3: #f29100;
  --accent4: #6eb8e8;
  --accent5: #a9aa00;
  --accent6: #0069b3;
  --hlink: #{$linkColor};
  --folHlink: #{$linkColorHover};
}

.reveal {
  h1 {
    color: var(--dk1);
  }

  h2 {
    color: var(--dk2);
  }

  h3 {
    color: var(--accent3);
  }

  h4 {
    color: var(--accent4);
  }

  h5 {
    color: var(--accent5);
  }

  h6 {
    color: var(--accent6);
  }

  section.has-dark-background {
    &,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: #fff;
    }
  }
}

// Theme template ------------------------------
@import "../node_modules/reveal.js/css/theme/template/theme";
// ---------------------------------------------

.reveal .slide-number {
  right: 8px;
  top: 8px;
  bottom: initial;
  font-family: $mainFont;
}

.reveal img {
  max-height: calc(100vh - 60px);
}
</style>
